import { Button, Modal } from '../ui'

export const AlertDialogAbandonClass = ({
  isOpen,
  onClose,
  onConfirm,
  eventTitle,
  eventTime,
}) => {
  const whatsappMessage = encodeURIComponent(
    `Hola, no puedo asistir "${eventTitle}" a las ${eventTime}. ¿Alguien quiere mi puesto? 🤔`
  )
  const whatsappUrl = `https://wa.me/?text=${whatsappMessage}`

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Menos de 1 hora para la clase"
      size="sm"
    >
      <p style={{ marginBottom: '12px', color: '#666', fontSize: '14px' }}>
        La clase abre en menos de 1 hora. Si abandonas, cede tu puesto a través
        de WhatsApp para que otra persona pueda venir. 🎯
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px',
          background: 'rgba(239,68,68,0.08)',
          border: '1px solid rgba(239,68,68,0.35)',
          borderRadius: '10px',
          padding: '10px 12px',
          marginBottom: '14px',
        }}
      >
        <span style={{ fontSize: '1.1rem', lineHeight: 1.4 }}>⚠️</span>
        <p
          style={{
            margin: 0,
            fontSize: '13px',
            fontWeight: 600,
            color: '#b91c1c',
            lineHeight: 1.45,
          }}
        >
          Después de compartir en WhatsApp, vuelve a la app y pulsa{' '}
          <strong>"Abandonar igualmente"</strong> para liberar tu plaza.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <Button size="md" variant="success" fullWidth>
            📱 Compartir en el grupo
          </Button>
        </a>
        <Button size="md" variant="danger" onClick={onConfirm} fullWidth>
          Abandonar igualmente
        </Button>
        <Button size="md" variant="secondary" onClick={onClose} fullWidth>
          Cancelar
        </Button>
      </div>
    </Modal>
  )
}
